
import BaseSelectComponent from "@/components/BaseForm/BaseSelect/BaseSelectComponent";
export default BaseSelectComponent;
